import {IReduxOrderProductFilesState} from '../../@interfaces';

const state: IReduxOrderProductFilesState = {
    uploadingFiles: {}
};

export default state;
